// extracted by mini-css-extract-plugin
export default {"container":"ChangeStatusModal_container__vbyZS","btn":"ChangeStatusModal_btn__XBjTq"};